module.exports = __webpack_public_path__ + "img/2017-2.a66c21f5.jpg";